module.exports = __webpack_public_path__ + "static/media/stringa_fondoscuro.f4339bad.png";